// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1IRgW","legacyBtn":"MutateMid_legacyBtn__1wIo-"};